import { render, staticRenderFns } from "./Document_Recored.vue?vue&type=template&id=d2f73f0a&"
import script from "./Document_Recored.vue?vue&type=script&lang=js&"
export * from "./Document_Recored.vue?vue&type=script&lang=js&"
import style0 from "./Document_Recored.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports